import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down-left",
  "use": "arrow-down-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"arrow-down-left\">\n<path d=\"M7,18c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l10-10c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-10,10C7.5,17.9,7.3,18,7,18z\" />\n<path d=\"M17,18H7c-0.6,0-1-0.4-1-1V7c0-0.6,0.4-1,1-1s1,0.4,1,1v9h9c0.6,0,1,0.4,1,1S17.6,18,17,18z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol